import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

const ROW_GRID = "grid grid-cols-[minmax(0,1fr)_11rem_5.5rem] items-center gap-5";

export function WarrantyListSkeleton(): ReactElement {
  return (
    <div className="space-y-1.5">
      <div className={ROW_GRID}>
        <Skeleton className="h-3 w-20" />
        <Skeleton className="ml-auto h-3 w-12" />
        <div />
      </div>

      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className={`${ROW_GRID} py-0.5`}>
          <Skeleton className="h-5 w-28" />
          <Skeleton className="ml-auto h-5 w-20" />
          <div className="flex justify-end gap-2">
            <Skeleton className="h-9 w-9 rounded-md" />
            <Skeleton className="h-9 w-9 rounded-md" />
          </div>
        </div>
      ))}

      <div className={`${ROW_GRID} py-0.5`}>
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <div className="flex justify-end">
          <Skeleton className="h-9 w-9 rounded-md" />
        </div>
      </div>
    </div>
  );
}
